import { render } from "./n06.vue?vue&type=template&id=00f2ecf7"
import script from "./n06.vue?vue&type=script&lang=js"
export * from "./n06.vue?vue&type=script&lang=js"

import exportComponent from "D:\\DevelopmentWork\\app\\JGJWork\\vue\\t3custom_2pos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__